export namespace Api {
  export type Error = {
    error: string
    message: string
    statusCode: number
    code: Errors
    unavailableProducts?: Array<{
      productVariantId: string
      productName: string
      sku: string
      reason: string
    }>
  }

  export type PaginatedResponse<Resource, Key extends string> = {
    page: number
    total: number
  } & {
    [key in Key]: Resource[]
  }
}

export const enum Errors {
  DISCOUNT_NOT_FOUND = 'DISCOUNT_NOT_FOUND',
  MEAL_PLAN_MINIMUM_DOSE_NOT_SATISFIED_ERROR = 'MEAL_PLAN_MINIMUM_DOSE_NOT_SATISFIED_ERROR',
  SUBSCRIPTION_NOT_EXTERNALLY_UPDATABLE_ERROR = 'SUBSCRIPTION_NOT_EXTERNALLY_UPDATABLE_ERROR',
  PRODUCTS_OUT_OF_STOCK = 'PRODUCTS_OUT_OF_STOCK',
  CLIENT_NOT_FOUND = 'CLIENT_NOT_FOUND',
  JWT_EXPIRED = 'JWT_EXPIRED',
  INVALID_SIGNATURE = 'INVALID_SIGNATURE',
  MISSING_AUTHORIZATION = 'Missing authorization',
  PROFILE_MISMATCH = 'PROFILE_MISMATCH'
}
